'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$13() {
  this.beI = null;
  this.beG = null;
  this.beH = false;
  this.beE = null;
  this.beF = false;
  this.beJ = false;
  this.beK = false;
  this.beI = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$13 as $c_Lpresto_PrestoRouter$$anon$13 };
$p = $c_Lpresto_PrestoRouter$$anon$13.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$13;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$13() {
}
export { $h_Lpresto_PrestoRouter$$anon$13 as $h_Lpresto_PrestoRouter$$anon$13 };
$h_Lpresto_PrestoRouter$$anon$13.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.beI;
});
$p.t = (function() {
  if ((!this.beH)) {
    this.beG = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.beH = true;
  }
  return this.beG;
});
$p.ae = (function() {
  if ((!this.beF)) {
    this.beE = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.beF = true;
  }
  return this.beE;
});
$p.w = (function() {
  if ((!this.beK)) {
    this.beJ = false;
    this.beK = true;
  }
  return this.beJ;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$13 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$13, "presto.PrestoRouter$$anon$13", ({
  NC: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$13 as $d_Lpresto_PrestoRouter$$anon$13 };
//# sourceMappingURL=presto.-Presto-Router$$anon$13.js.map
